import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Typography, Paper, Button, Container } from '@mui/material';
import { CheckCircle, ArrowRight } from 'lucide-react';
import Checkout from './Checkout';
import { api, apiUrl } from '../../services/api';
import { AlertInfo } from '../../components/Alerts/Alert';
import SimpleBackdrop from '../../components/Loading/SimpleBackdrop';
import { Plan } from './types';
// import RegistrationHeader from './CadEscriComponents/RegistrationHeader';

const ContractPlan: React.FC = () => {
    const { plano = 'plano-mensal' } = useParams();
    const [openLoad, setOpenLoad] = useState(false);
    const [plan, setPlan] = useState({ id: '0', price: 0 });

    async function fetchPlans() {
        setOpenLoad(true);
        try {
            const response = await api.get(`/getplanssys`);
            if (response && response.data) {
                const allPlans = response.data;
                let codPlan = 1;
                if (plano === 'plano-semestral') codPlan = 3;
                else if (plano === 'plano-anual') codPlan = 4;
                const selectPlan: Plan | undefined = allPlans.find((item: Plan) => Number(item.cod_plan) === codPlan);
                if (selectPlan) setPlan({ id: selectPlan.cod_plan, price: selectPlan.price_payment });
            }
        } catch (error) {
            console.log(error);
            AlertInfo({ icon: 'error', title: 'Falha ao obter planos', text: 'Verifique a conexão com a internet' });
        }
        setOpenLoad(false);
    }

    useEffect(() => {
        fetchPlans();
    }, []);

    return (
        <Container maxWidth="lg">
            <SimpleBackdrop open={openLoad} />
            <Paper
                elevation={5}
                sx={{
                    textAlign: 'center',
                    borderRadius: 3,
                    bgcolor: 'background.paper',
                    position: 'relative',
                    overflow: 'hidden'
                }}
            >
                <Box>
                    <img src={`${apiUrl}/img/logo-2-sysprojud`} height={70} alt="Logo SysProJud"></img>
                </Box>
                <Checkout planPrice={plan.price} selectedPlan={plan.id} channel='/congratulations' />
            </Paper>
        </Container>
    );
};

export default ContractPlan;